module.exports = "<div> <iframe-template path-url={{url}} css=100% key=templateDetail></iframe-template> </div>";


//////////////////
// WEBPACK FOOTER
// ./src/app/system/settingcenter/templateSetting/view/templateDetail.html
// module id = 6GYU
// module chunks = 0